angular.module('gantt.movable.templates', []).run(['$templateCache', function($templateCache) {

}]);
